export default __webpack_public_path__ + "static/media/mon.ae76dcca.jpg";